import _defineProperty from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _LAYOUTS;
export var LAYOUT_TYPE = {
  integrations: 'integrations',
  partners: 'partners',
  awards: 'awards',
  compact: 'compact'
};
var LAYOUTS = (_LAYOUTS = {}, _defineProperty(_LAYOUTS, LAYOUT_TYPE.integrations, {
  height: 56,
  margin: 55,
  width: 105
}), _defineProperty(_LAYOUTS, LAYOUT_TYPE.partners, {
  height: 35,
  margin: -2,
  width: 168
}), _defineProperty(_LAYOUTS, LAYOUT_TYPE.awards, {
  height: 125,
  margin: 55,
  width: 125
}), _defineProperty(_LAYOUTS, LAYOUT_TYPE.compact, {
  height: 25,
  width: 168
}), _LAYOUTS);
export var getLayoutByType = function getLayoutByType(type) {
  return LAYOUTS[type] || LAYOUTS[LAYOUT_TYPE.integrations];
};